<template>
  <div :class="classes">
    <ui-icon 
      class="cart-badge__icon" 
      glyph="bag" 
      />

    <data-badge 
      class="cart-badge__badge"
      v-if="nCartItem > 0" 
      :value="nCartItem" 
      />
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'

export default {
  name: 'CheckoutCartBadge',

  computed: {
    ...mapState({
      cart: state => state['sayl-oat'].cart,
    }),
    
    classes(){
      return {
        'cart-badge': true,
        '-is-active': this.nCartItem > 0
      }
    },

    nCartItem(){
      return this.cart ? this.cart.items.length : 0;
    },
  }
}
</script>
